import React from 'react';
function Email({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16 8.4v4.5c0 .716-.116 1.402.39 1.909a2.7 2.7 0 004.61-1.91V12a9 9 0 10-3.528 7.146"
      />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 16a4 4 0 100-8 4 4 0 000 8z" />
    </svg>
  );
}

export default Email;
